import { render, staticRenderFns } from "./FooterX2.vue?vue&type=template&id=3d3c0f7a&scoped=true"
import script from "./FooterX2.vue?vue&type=script&lang=js"
export * from "./FooterX2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c0f7a",
  null
  
)

export default component.exports